module.exports = __webpack_public_path__ + "static/portal-28adc198ae7b9bd8021f6ec47115ed79.mp4";